import React from "react";
import styled from "styled-components";
import { Tooltip, tooltipClasses } from "@mui/material";

const CustomTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.background.tooltip,
        lineHeight: 1.5,
        fontSize: 12,
        padding: 18,
    },
}));

export default CustomTooltip;
